import { css } from 'styled-components';

export const visibilityAnimationRight = css`
  &.animated {
    right: 0;
    opacity: 1;
    transition: right 0.3s cubic-bezier(0.65, 0, 0.35, 1),
      opacity 0.3s cubic-bezier(0.65, 0, 0.35, 1);
  }
`;

export const maxWidthModalCreateJourney = '526px';
